import React, { Fragment } from 'react';
export const cleanString = text => text.trim().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
export function normalizeFieldName(fieldName, pattern, forceLowerCase) {
  if (forceLowerCase === void 0) {
    forceLowerCase = true;
  }
  const patt = new RegExp(pattern || '[^a-zA-Z0-9_]');
  let val = '';
  let name = fieldName.trim().replace(/\s|-/g, '_');
  name = cleanString(name);
  name = name.split('');
  name.forEach(letter => {
    if (!patt.test(letter)) {
      val += letter;
    }
  });

  // replace consecutive _
  val = val.replace(/_+/g, '_');
  if (forceLowerCase) val = val.toLowerCase();
  return val;
}
export const capitalize = item => item.charAt(0).toUpperCase() + item.slice(1);
export const copyValue = (data, toast) => {
  const textField = document.createElement('textarea');
  textField.innerText = data.message;
  document.body.appendChild(textField);
  textField.select();
  document.execCommand('copy');
  textField.remove();
  toast && toast;
};
export const getFirstTwoInitials = name => {
  if (!name) return '';
  let initials = name.match(/\b\w/g) || [];
  const firstInitial = initials.shift();
  const lastInitial = initials.pop();
  initials = [firstInitial, lastInitial];
  initials = initials.join('').toUpperCase().substring(0, 2);
  return initials;
};
export const replaceWords = (obj, search, replace) => {
  const regExp = new RegExp(`(^|[^a-zA-ZΆΈ-ώἀ-ῼ\\n])(${search})(?![a-zA-ZΆΈ-ώἀ-ῼ])`, 'gm');
  const retStr = obj.replace(regExp, match => {
    if (match.length === 0 || replace.length === 0) {
      return replace;
    }
    let rpl = replace;
    const regex = new RegExp("(\\s|[!@#$%\\^&*)(+=._-]|'|’)");
    const firstCh = match[0];
    const firstRplCh = replace[0];
    if (regex.test(firstCh) === true && firstCh !== firstRplCh) {
      rpl = `${firstCh}${rpl}`;
    }
    const lastCh = match[match.length - 1];
    const lastRplCh = replace[replace.length - 1];
    if (regex.test(lastCh) === true && lastCh !== lastRplCh) {
      rpl = `${rpl}${lastCh}`;
    }
    return rpl;
  });
  return retStr;
};
var _ref = /*#__PURE__*/React.createElement("br", null);
export const breakLines = string => string.split('\\n').map((line, i) => /*#__PURE__*/React.createElement(Fragment, {
  key: i
}, /*#__PURE__*/React.createElement("span", null, line), _ref));